module.exports = __webpack_public_path__ + "img/shimmer.93d44294.png";